import React, { useEffect } from "react";
import { FormatMoney } from "../../../Helpers/FormatNumber";

class DashPresaInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: false,
    };
    this.divRef = React.createRef(null);
    this.width = 300;
  }

  openModal = () => {
    this.setState({ isModalOpen: true });
    var element = document.getElementsByClassName(this.props.presa.clavesih);
    if (element !== undefined && element !== null) {
    }
    // console.log(this.props.presa);
  };
  onClickModal = () => {};

  closeModal = () => {
    this.setState({ isModalOpen: false });
  };
  // <div className={this.props.classNameInfo} ref={this.divRef}>
  render() {
    return (
      <div
        id={this.props.presa.clavesih}
        className="presas-name-hover"
        onMouseEnter={this.openModal}
        onMouseLeave={this.closeModal}
      >
        <div className={this.props.classNameInfo} ref={this.divRef}>
          <div className="lbl-presas">{this.props.nombre}</div>
          <div className="dash-presas-porcentaje">{this.props.porcentaje}%</div>
        </div>

        {this.state.isModalOpen ? (
          <div
            style={{
              top:
                this.divRef.current.offsetTop +
                this.divRef.current.offsetHeight,
              left:
                this.divRef.current.offsetLeft +
                (this.divRef.current.offsetWidth - this.width) / 2,
              width: this.width,
              position: "absolute",
            }}
            // className="dnone"
          >
            <div className="dash-modal-arrow-up"></div>
            <div className="dash-modal-shadow dash-modal-card">
              <div className="dash-modal-title">
                <strong> {this.props.nombre} </strong>
              </div>
              <div className="dash-modal-subtitle">
                <strong>Situacion Actual</strong>
              </div>
              <div className="dash-modal-content">
                <div>
                  <strong>Fecha:</strong> {this.props.presa.fechamonitoreo}
                </div>
                <div>
                  <strong>Elevación: </strong>
                  {this.props.presa.elevacionactual} msnm
                </div>
                <div>
                  <strong>Almacenamiento: </strong>{" "}
                  {this.props.presa.almacenaactual} hm³
                </div>
                <div>
                  <strong>Porcentaje de llenado:</strong>{" "}
                  {FormatMoney(this.props.presa.llenano * 100)}%
                </div>
              </div>
              <div className="dash-modal-subtitle">
                <strong>Ubicación</strong>
              </div>
              <div class="dash-modal-content">
                <div>
                  <strong>Corriente donde se ubica:</strong>{" "}
                  {this.props.presa.corriente}
                </div>
                <div>
                  <strong>Municipio: </strong>
                  {this.props.presa.nommunicipio}
                </div>
                <div>
                  <strong>Entidad federativa: </strong>{" "}
                  {this.props.presa.estado}
                </div>
                <div>
                  <strong>Región administrativa:</strong>{" "}
                  {this.props.presa.regioncna}
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

export default DashPresaInfo;
